import { useEffect, useState } from 'react'
import { Checkbox, Popover, Tooltip, Typography } from 'antd'
import CustomAntButton from 'general/components/Button/CustomAntButton'
import { useDispatch } from 'react-redux'
import {
  useColumns,
  useColumnsDispatch,
} from 'features/TemplateInvoice/screens/CreateTemplateInvoice/ColumnsContext'

export default function AddFeildInvoiceProduct({
  RegionConfigs,
  setSpecifiedRegion,
  activeRegion,
}) {
  const [isOpen, setIsOpen] = useState(false)
  const [itemFeildData, setItemFeildData] = useState({})
  const dispatch = useDispatch()
  const columnsDispatch = useColumnsDispatch()
  const handleTogglePopover = () => {
    setIsOpen((prev) => !prev)
  }

  const onChange = (data) => {
    updateBusinessBranchFields(true, data, 1)
  }

  const tableDetailColumns = useColumns('tableDetailColumns')
  const setTableDetailColumns = (payload) => {
    columnsDispatch({
      type: 'set',
      colsName: 'tableDetailColumns',
      payload,
    })
  }
  const tableDetail1Columns = useColumns('tableDetail1Columns')
  const setTableDetail1Columns = (payload) => {
    columnsDispatch({
      type: 'set',
      colsName: 'tableDetail1Columns',
      payload,
    })
  }

  const updateBusinessBranchFields = (checkValue, data, checkbox) => {
    console.log('RegionConfigs', RegionConfigs)
    const infoRegion = RegionConfigs.find(
      (region) => region.regionName === activeRegion?.regionName,
    )
    if (!infoRegion) return
    const businessFields = [
      {
        dataField: data?.key,
        label: data?.label,
        labelEn: '',
      },
    ]

    const updatedRegionConfigs = [...infoRegion.regionConfigs]

    businessFields.forEach((item) => {
      const index = updatedRegionConfigs.findIndex(
        (field) => field.dataField === item.dataField,
      )

      if (index !== -1) {
        // Đã có -> cập nhật show
        updatedRegionConfigs[index] = {
          ...updatedRegionConfigs[index],
          ...(checkbox
            ? checkValue
              ? { show: 1 }
              : { show: 0 }
            : checkValue
              ? {}
              : {}),
          // ...(checkValue ? {} : { show: 0 }),
          value: {
            value: data?.[item.dataField],
            editable: false,
          },
        }
      } else {
        // Chưa có -> thêm mới
        updatedRegionConfigs.push({
          dataField: item.dataField,
          label: {
            value: item.label,
            lineHeight: 1.4,
            fontWeight: 'bold',
            textAlign: 'center',
          },
          labelEn: {
            fontStyle: 'italic',
            fontWeight: 'bold',
            lineHeight: 1.4,
            textAlign: 'center',
            value: item.labelEn,
          },
          value: {
            value: data?.[item.dataField],
            editable: false,
          },
          show: checkValue ? 1 : 0,
          children: [],
        })
      }
    })
    dispatch(
      setSpecifiedRegion({
        regionName: activeRegion?.regionName,
        propertyData: {
          regionConfigs: updatedRegionConfigs,
        },
      }),
    )
  }

  useEffect(() => {
    if (!activeRegion?.regionName) return

    const infoRegion = RegionConfigs.find(
      (region) => region.regionName === activeRegion.regionName,
    )

    const existingFields = new Set(
      infoRegion?.regionConfigs?.map((field) => field.dataField),
    )

    const fields_tableDetail = [
      { key: 'lotNumber', label: 'Số lô' },
      { key: 'expirationDate', label: 'Hạn sử dụng' },
      { key: 'barcode', label: 'Mã vạch' },
    ]
    const fields_sellerInfo = []

    setItemFeildData({
      tableDetail: fields_tableDetail.filter(
        ({ key }) => !existingFields.has(key),
      ),
      tableDetail1: fields_tableDetail.filter(
        ({ key }) => !existingFields.has(key),
      ),
      sellerInfo: fields_sellerInfo.filter(
        ({ key }) => !existingFields.has(key),
      ),
    })
  }, [activeRegion?.regionName])

  const resizeWidestColumn = () => {
    const cells = [...document.querySelectorAll('th.react-resizable')]
    if (!cells.length) return
    const widestCell = cells.reduce((max, cell) => {
      const width = cell.getBoundingClientRect().width
      const maxWidth = max.getBoundingClientRect().width

      return width > maxWidth ? cell : max
    })
    const handle = widestCell.querySelector(
      '.react-resizable-handle.react-resizable-handle-se',
    )
    if (!handle) return

    const rect = handle.getBoundingClientRect()
    const startX = rect.left + rect.width / 2
    const startY = rect.top + rect.height / 2
    const width = widestCell.getBoundingClientRect().width
    const deltaX = width / 2

    handle.dispatchEvent(
      new MouseEvent('mousedown', {
        bubbles: true,
        clientX: startX,
        clientY: startY,
      }),
    )

    for (let i = 1; i <= 10; i++) {
      document.dispatchEvent(
        new MouseEvent('mousemove', {
          bubbles: true,
          clientX: startX - (deltaX * i) / 10,
          clientY: startY,
        }),
      )
    }

    document.dispatchEvent(
      new MouseEvent('mouseup', {
        bubbles: true,
        clientX: startX - deltaX,
        clientY: startY,
      }),
    )
  }

  return (
    <>
      <Popover
        open={isOpen}
        onOpenChange={setIsOpen}
        placement="left"
        content={
          <div style={{ width: 350, maxHeight: 320, overflowY: 'auto' }}>
            <Typography.Title level={5}>
              Bổ sung nội dung chi tiết hóa đơn mặc định
            </Typography.Title>
            <div>
              {(itemFeildData?.[activeRegion?.regionName] ?? []).map(
                ({ key, label }) => (
                  <div key={key}>
                    <Checkbox
                      onChange={() => {
                        onChange({ key, label })
                        setItemFeildData((prev) => ({
                          ...prev,
                          [activeRegion.regionName]: prev[
                            activeRegion.regionName
                          ].filter((item) => item.key !== key),
                        }))
                        resizeWidestColumn()
                      }}
                    >
                      {label}
                    </Checkbox>
                  </div>
                ),
              )}
            </div>
          </div>
        }
      ></Popover>
      {itemFeildData?.[activeRegion?.regionName]?.length > 0 ? (
        <div style={{ position: 'relative', right: -28 }}>
          <Tooltip title="Bổ sung nội dung chi tiết hóa đơn mặc định">
            <span>
              <CustomAntButton
                iconCn="fa-regular fa-gear"
                antProps={{
                  type: 'default',
                  className: 'p-3',
                  shape: 'round',
                  onClick: handleTogglePopover,
                }}
                customStyle={{
                  minWidth: 'fit-content',
                }}
              />
            </span>
          </Tooltip>
        </div>
      ) : (
        <></>
      )}
    </>
  )
}
